import React, { useState } from 'react';
import { useOutletContext, useParams } from 'react-router-dom';

import { formatDateForDisplay } from '../../../helpers/date-time';

import ButtonIcon from '../../../component-library/button-icon';
import downloadFile from '../../../helpers/download-file';

const Attachments = () => {
	const { data, uiMenuConfig } = useOutletContext();
	const { id } = useParams();
	const [downloading, setDownloading] = useState('');

	const downloadItem = attachmentId => {
		const uri = `/api/web/catalog/item/${id}/attachments/${attachmentId}`;
		downloadFile(uri, () => setDownloading(attachmentId), () => setDownloading(''));
	};

	return (
		<>
			<h3>{uiMenuConfig?.attachments?.label || 'Attachments'}</h3>
			<table className="table is-bordered">
				<thead>
					<tr>
						<th>Name</th>
						<th>Type</th>
						<th>Date Updated</th>
						<th> </th>
					</tr>
				</thead>
				<tbody>
					{data?.attachments.length ? (
						data.attachments.map((item, index) => (
							// eslint-disable-next-line react/no-array-index-key
							<tr key={index}>
								<td>{item.name}</td>
								<td>{item.contentType}</td>
								<td>{formatDateForDisplay(item.dateUpdated)}</td>
								<td className="text-right">
									<ButtonIcon
										icon={downloading === item.id ? 'spinner' : 'download'}
										title="Download File"
										onClick={() => downloadItem(item.id)}
										isDisabled={downloading === item.id}
										iconSpin={downloading === item.id}
									/>
								</td>
							</tr>
						))
					) : (
						<tr>
							<td colSpan={4} className="grey-text text-center">No attachments available.</td>
						</tr>
					)}
				</tbody>
			</table>
		</>
	);
};

export default Attachments;
